/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import axios from "axios"
import VueAxios from "vue-axios"
import Vuelidate from 'vuelidate'
import store from "./store/index"
import VueHead from "vue-head"

import MainPlugin from "./mainPlugin"
import { getAvailableSitesByRole } from "./utils/userRoleSite"
import PortalVue from "portal-vue"

/* import * as Sentry from "@sentry/vue" */
// import { Integrations } from "@sentry/tracing"
import VueMeta from 'vue-meta'
import HighchartsVue from 'highcharts-vue'
import moment from 'moment'

import Vuetify from 'vuetify'

Vue.use(Vuetify)

Vue.prototype.moment = moment
require('moment/locale/nl')
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(PortalVue)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(MainPlugin)
Vue.use(VueHead)
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
Vue.use(HighchartsVue)

import Tracker from '@openreplay/tracker';

const tracker = new Tracker({
  projectKey: "Hov5hh4xyxXxRnfT2FyP",
  ingestPoint: "https://replay.omni-cloud.io/ingest",
});
tracker.start();


import ClickOutside from 'vue-click-outside'
import Sticky from './directives/sticky'

Vue.directive('click-outside', ClickOutside)
Vue.directive('Sticky', Sticky);


import LogRocket from 'logrocket'
LogRocket.init('0gwjv1/backoffice-ir0nb')


// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// router setup
import routes from './routes/routes'

import './registerServiceWorker'
// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)

const production = process.env.NODE_ENV !== "development"
const LAST_VISITED_KEY = 'last-visited'
// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history", // added history mode in order to remove "/#/" hash
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  if (!to.path.includes("/admin") && !to.path.includes("/site-editor")) return next()

  if (!store.state.loadedUser) {
    try {
      const {data: user} = await axios.get(`/api/accounts/me`)
      store.commit("setUser", user)
    } catch (err) {
      await axios.get("/logout")
      store.commit("setUser", null)
      location.href = "/sign-in"
    }
  }

  let toPathWidthId = null;

  if(Object.keys(to.params).length) {
    toPathWidthId = to.path.replace(`${to.params['id']}`, `:id`)
  }

  const availablePaths = getAvailableSitesByRole(store.state.user && store.state.user.role)
  const lastVisitedPage = localStorage.getItem(LAST_VISITED_KEY)
  /*const shouldRedirect = Boolean(
    to.path == "/admin/websites" &&
    lastVisitedPage
  )*/
  const shouldRedirect = false

  if (!availablePaths || availablePaths.some(path => to.path.includes(path)) || availablePaths.includes(toPathWidthId)) {
    shouldRedirect ? next({path: lastVisitedPage}) : next()
  } else {
    next(availablePaths[0])
  }
})

import './assets/css/tailwind.css';

router.afterEach(to => {
  if (to.path.includes("/admin")) {
    localStorage.setItem(LAST_VISITED_KEY, to.path)
  }
})
// import './assets/css/tailwind.css';


/* if (production) {
  Sentry.init({
    Vue,
    dsn: "https://29bbb04c2d1c4d83b30440aabc372b42@o481243.ingest.sentry.io/6115387",
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "backoffice-dev.hadiethshop.nl", "https://backoffice.hadiethshop.nl/", /^\//],
      })
    ],
    tracesSampleRate: 1.0
  })
}
 */
/*
  try {
    const {data} = await this.axios.get(`/api/accounts/me`)
    this.$store.commit("setUser", data)
  } catch (err) {}
*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router,
  vuetify: new Vuetify()
})
